export const matchesDB = [
  // ==================== 2026年KPL春季赛（来源：kpl.qq.com + 快懂百科 + 新浪新闻 + 虎扑） ====================
  
  // ===== 总决赛（1场） =====
  {
    id: 'm2026_final',
    tournament: '2026年KPL春季赛总决赛',
    stage: '总决赛',
    date: '2026-04-11',
    time: '18:00',
    venue: '海口五源河文化体育中心',
    status: 'finished',
    teamA: { id: 1, name: '苏州KSG', shortName: 'KSG', score: 4, logo: '', color: '#8B5CF6' },
    teamB: { id: 2, name: '重庆狼队', shortName: '狼队', score: 0, logo: '', color: '#FFD700' },
    result: 'KSG胜',
    format: 'BO7',
    dataSource: 'https://kpl.qq.com/#/Schedule',
    verified: true,
    note: 'KSG队史首冠'
  },

  // ===== 季后赛（12场） =====
  {
    id: 'm2026_po_0405',
    tournament: '2026年KPL春季赛季后赛',
    stage: '败者组决赛',
    date: '2026-04-05',
    time: '18:30',
    venue: '',
    status: 'finished',
    teamA: { id: 1, name: '苏州KSG', shortName: 'KSG', score: 4, logo: '', color: '#8B5CF6' },
    teamB: { id: 3, name: '成都AG超玩会', shortName: 'AG', score: 2, logo: '', color: '#FF6B00' },
    result: 'KSG胜',
    format: 'BO7',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_po_0404',
    tournament: '2026年KPL春季赛季后赛',
    stage: '败者组半决赛',
    date: '2026-04-04',
    time: '18:30',
    venue: '',
    status: 'finished',
    teamA: { id: 1, name: '苏州KSG', shortName: 'KSG', score: 4, logo: '', color: '#8B5CF6' },
    teamB: { id: 6, name: '北京WB', shortName: 'WB', score: 1, logo: '', color: '#FF4500' },
    result: 'KSG胜',
    format: 'BO7',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_po_0403',
    tournament: '2026年KPL春季赛季后赛',
    stage: '胜者组决赛',
    date: '2026-04-03',
    time: '18:30',
    venue: '',
    status: 'finished',
    teamA: { id: 2, name: '重庆狼队', shortName: '狼队', score: 4, logo: '', color: '#FFD700' },
    teamB: { id: 3, name: '成都AG超玩会', shortName: 'AG', score: 0, logo: '', color: '#FF6B00' },
    result: '狼队胜',
    format: 'BO7',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true,
    note: '狼队第5次晋级决赛'
  },
  {
    id: 'm2026_po_0402',
    tournament: '2026年KPL春季赛季后赛',
    stage: '败者组第三轮',
    date: '2026-04-02',
    time: '18:30',
    venue: '',
    status: 'finished',
    teamA: { id: 1, name: '苏州KSG', shortName: 'KSG', score: 4, logo: '', color: '#8B5CF6' },
    teamB: { id: 8, name: '深圳DYG', shortName: 'DYG', score: 1, logo: '', color: '#00CED1' },
    result: 'KSG胜',
    format: 'BO7',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_po_0331',
    tournament: '2026年KPL春季赛季后赛',
    stage: '败者组第二轮',
    date: '2026-03-31',
    time: '18:30',
    venue: '',
    status: 'finished',
    teamA: { id: 4, name: '广州TTG', shortName: 'TTG', score: 2, logo: '', color: '#FF4444' },
    teamB: { id: 8, name: '深圳DYG', shortName: 'DYG', score: 3, logo: '', color: '#00CED1' },
    result: 'DYG胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_po_0330',
    tournament: '2026年KPL春季赛季后赛',
    stage: '败者组第二轮',
    date: '2026-03-30',
    time: '18:30',
    venue: '',
    status: 'finished',
    teamA: { id: 12, name: '杭州LGD.NBW', shortName: 'LGD', score: 3, logo: '', color: '#9370DB' },
    teamB: { id: 6, name: '北京WB', shortName: 'WB', score: 4, logo: '', color: '#FF4500' },
    result: 'WB胜',
    format: 'BO7',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_po_0329',
    tournament: '2026年KPL春季赛季后赛',
    stage: '胜者组第一轮',
    date: '2026-03-29',
    time: '18:30',
    venue: '',
    status: 'finished',
    teamA: { id: 2, name: '重庆狼队', shortName: '狼队', score: 4, logo: '', color: '#FFD700' },
    teamB: { id: 1, name: '苏州KSG', shortName: 'KSG', score: 3, logo: '', color: '#8B5CF6' },
    result: '狼队胜',
    format: 'BO7',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_po_0328',
    tournament: '2026年KPL春季赛季后赛',
    stage: '胜者组第一轮',
    date: '2026-03-28',
    time: '18:30',
    venue: '',
    status: 'finished',
    teamA: { id: 3, name: '成都AG超玩会', shortName: 'AG', score: 4, logo: '', color: '#FF6B00' },
    teamB: { id: 14, name: '北京JDG', shortName: 'JDG', score: 0, logo: '', color: '#0000CD' },
    result: 'AG胜',
    format: 'BO7',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_po_0327',
    tournament: '2026年KPL春季赛季后赛',
    stage: '败者组第一轮',
    date: '2026-03-27',
    time: '18:30',
    venue: '',
    status: 'finished',
    teamA: { id: 4, name: '广州TTG', shortName: 'TTG', score: 4, logo: '', color: '#FF4444' },
    teamB: { id: 16, name: '南通Hero久竞', shortName: 'Hero', score: 1, logo: '', color: '#32CD32' },
    result: 'TTG胜',
    format: 'BO7',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_po_0326',
    tournament: '2026年KPL春季赛季后赛',
    stage: '败者组第一轮',
    date: '2026-03-26',
    time: '18:30',
    venue: '',
    status: 'finished',
    teamA: { id: 12, name: '杭州LGD.NBW', shortName: 'LGD', score: 4, logo: '', color: '#9370DB' },
    teamB: { id: 18, name: '桐乡情久', shortName: '情久', score: 3, logo: '', color: '#FF69B4' },
    result: 'LGD胜',
    format: 'BO7',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },

  // ===== 常规赛第三轮（14场） - 来源：快懂百科 + kpl.qq.com =====
  {
    id: 'm2026_r3_0321b',
    tournament: '2026年KPL春季赛常规赛第三轮',
    stage: 'S组',
    date: '2026-03-21',
    time: '20:00',
    venue: '',
    status: 'finished',
    teamA: { id: 2, name: '重庆狼队', shortName: '狼队', score: 3, logo: '', color: '#FFD700' },
    teamB: { id: 3, name: '成都AG超玩会', shortName: 'AG', score: 0, logo: '', color: '#FF6B00' },
    result: '狼队胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true,
    note: '狼队四连胜收官S组'
  },
  {
    id: 'm2026_r3_0321a',
    tournament: '2026年KPL春季赛常规赛第三轮',
    stage: 'S组',
    date: '2026-03-21',
    time: '18:30',
    venue: '',
    status: 'finished',
    teamA: { id: 14, name: '北京JDG', shortName: 'JDG', score: 3, logo: '', color: '#0000CD' },
    teamB: { id: 8, name: '深圳DYG', shortName: 'DYG', score: 1, logo: '', color: '#00CED1' },
    result: 'JDG胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true,
    note: 'JDG全胜通关S组'
  },
  {
    id: 'm2026_r3_0320',
    tournament: '2026年KPL春季赛常规赛第三轮',
    stage: 'A组',
    date: '2026-03-20',
    time: '18:30',
    venue: '',
    status: 'finished',
    teamA: { id: 12, name: '杭州LGD.NBW', shortName: 'LGD', score: 3, logo: '', color: '#9370DB' },
    teamB: { id: 9, name: '长沙TES.A', shortName: 'TES', score: 0, logo: '', color: '#20B2AA' },
    result: 'LGD胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true,
    note: 'LGD六连胜'
  },
  {
    id: 'm2026_r3_0319',
    tournament: '2026年KPL春季赛常规赛第三轮',
    stage: 'S/A组',
    date: '2026-03-19',
    time: '18:30',
    venue: '',
    status: 'finished',
    teamA: { id: 6, name: '北京WB', shortName: 'WB', score: 3, logo: '', color: '#FF4500' },
    teamB: { id: 8, name: '深圳DYG', shortName: 'DYG', score: 1, logo: '', color: '#00CED1' },
    result: 'WB胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_r3_0318b',
    tournament: '2026年KPL春季赛常规赛第三轮',
    stage: 'S组',
    date: '2026-03-18',
    time: '20:00',
    venue: '',
    status: 'finished',
    teamA: { id: 2, name: '重庆狼队', shortName: '狼队', score: 3, logo: '', color: '#FFD700' },
    teamB: { id: 1, name: '苏州KSG', shortName: 'KSG', score: 2, logo: '', color: '#8B5CF6' },
    result: '狼队胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true,
    note: '锁定胜者组名额'
  },
  {
    id: 'm2026_r3_0318a',
    tournament: '2026年KPL春季赛常规赛第三轮',
    stage: 'S组',
    date: '2026-03-18',
    time: '18:30',
    venue: '',
    status: 'finished',
    teamA: { id: 14, name: '北京JDG', shortName: 'JDG', score: 3, logo: '', color: '#0000CD' },
    teamB: { id: 3, name: '成都AG超玩会', shortName: 'AG', score: 2, logo: '', color: '#FF6B00' },
    result: 'JDG胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_r3_0315',
    tournament: '2026年KPL春季赛常规赛第三轮',
    stage: 'A组',
    date: '2026-03-15',
    time: '18:30',
    venue: '',
    status: 'finished',
    teamA: { id: 9, name: '长沙TES.A', shortName: 'TES', score: 0, logo: '', color: '#20B2AA' },
    teamB: { id: 18, name: '桐乡情久', shortName: '情久', score: 3, logo: '', color: '#FF69B4' },
    result: '情久胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_r3_0314',
    tournament: '2026年KPL春季赛常规赛第三轮',
    stage: 'S组',
    date: '2026-03-14',
    time: '18:30',
    venue: '',
    status: 'finished',
    teamA: { id: 1, name: '苏州KSG', shortName: 'KSG', score: 3, logo: '', color: '#8B5CF6' },
    teamB: { id: 3, name: '成都AG超玩会', shortName: 'AG', score: 1, logo: '', color: '#FF6B00' },
    result: 'KSG胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_r3_0312',
    tournament: '2026年KPL春季赛常规赛第三轮',
    stage: 'S组',
    date: '2026-03-12',
    time: '18:30',
    venue: '',
    status: 'finished',
    teamA: { id: 3, name: '成都AG超玩会', shortName: 'AG', score: 3, logo: '', color: '#FF6B00' },
    teamB: { id: 8, name: '深圳DYG', shortName: 'DYG', score: 0, logo: '', color: '#00CED1' },
    result: 'AG胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_r3_0311b',
    tournament: '2026年KPL春季赛常规赛第三轮',
    stage: 'S组',
    date: '2026-03-11',
    time: '20:00',
    venue: '',
    status: 'finished',
    teamA: { id: 6, name: '北京WB', shortName: 'WB', score: 2, logo: '', color: '#FF4500' },
    teamB: { id: 2, name: '重庆狼队', shortName: '狼队', score: 3, logo: '', color: '#FFD700' },
    result: '狼队胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_r3_0311a',
    tournament: '2026年KPL春季赛常规赛第三轮',
    stage: 'S组',
    date: '2026-03-11',
    time: '18:30',
    venue: '',
    status: 'finished',
    teamA: { id: 14, name: '北京JDG', shortName: 'JDG', score: 3, logo: '', color: '#0000CD' },
    teamB: { id: 1, name: '苏州KSG', shortName: 'KSG', score: 2, logo: '', color: '#8B5CF6' },
    result: 'JDG胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_r3_0308b',
    tournament: '2026年KPL春季赛常规赛第三轮',
    stage: 'S组',
    date: '2026-03-08',
    time: '20:00',
    venue: '',
    status: 'finished',
    teamA: { id: 14, name: '北京JDG', shortName: 'JDG', score: 3, logo: '', color: '#0000CD' },
    teamB: { id: 2, name: '重庆狼队', shortName: '狼队', score: 2, logo: '', color: '#FFD700' },
    result: 'JDG胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_r3_0308a',
    tournament: '2026年KPL春季赛常规赛第三轮',
    stage: 'S组',
    date: '2026-03-08',
    time: '15:00',
    venue: '',
    status: 'finished',
    teamA: { id: 1, name: '苏州KSG', shortName: 'KSG', score: 3, logo: '', color: '#8B5CF6' },
    teamB: { id: 8, name: '深圳DYG', shortName: 'DYG', score: 1, logo: '', color: '#00CED1' },
    result: 'KSG胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_r3_0307',
    tournament: '2026年KPL春季赛常规赛第三轮',
    stage: 'S组',
    date: '2026-03-07',
    time: '18:30',
    venue: '',
    status: 'finished',
    teamA: { id: 3, name: '成都AG超玩会', shortName: 'AG', score: 3, logo: '', color: '#FF6B00' },
    teamB: { id: 6, name: '北京WB', shortName: 'WB', score: 2, logo: '', color: '#FF4500' },
    result: 'AG胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },

  // ===== 卡位赛（3场） =====
  {
    id: 'm2026_kw_0304b',
    tournament: '2026年KPL春季赛卡位赛',
    stage: 'S/A卡位赛',
    date: '2026-03-04',
    time: '20:00',
    venue: '',
    status: 'finished',
    teamA: { id: 3, name: '成都AG超玩会', shortName: 'AG', score: 4, logo: '', color: '#FF6B00' },
    teamB: { id: 4, name: '广州TTG', shortName: 'TTG', score: 2, logo: '', color: '#FF4444' },
    result: 'AG胜',
    format: 'BO7',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true,
    note: 'AG晋级S组+季后赛'
  },
  {
    id: 'm2026_kw_0304a',
    tournament: '2026年KPL春季赛卡位赛',
    stage: 'S/A卡位赛',
    date: '2026-03-04',
    time: '18:30',
    venue: '',
    status: 'finished',
    teamA: { id: 18, name: '桐乡情久', shortName: '情久', score: 3, logo: '', color: '#FF69B4' },
    teamB: { id: 14, name: '北京JDG', shortName: 'JDG', score: 4, logo: '', color: '#0000CD' },
    result: 'JDG胜',
    format: 'BO7',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_kw_0303',
    tournament: '2026年KPL春季赛卡位赛',
    stage: 'A/B卡位赛',
    date: '2026-03-03',
    time: '18:30',
    venue: '',
    status: 'finished',
    teamA: { id: 11, name: '西安WE', shortName: 'WE', score: 4, logo: '', color: '#FF69B4' },
    teamB: { id: 5, name: '武汉eStarPro', shortName: 'eStar', score: 2, logo: '', color: '#FFD700' },
    result: 'WE胜',
    format: 'BO7',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true,
    note: 'eStar无缘季后赛'
  },

  // ===== 常规赛第二轮（13场） =====
  {
    id: 'm2026_r2_0226',
    tournament: '2026年KPL春季赛常规赛第二轮',
    stage: 'S/A组',
    date: '2026-02-26',
    time: '18:30',
    venue: '',
    status: 'finished',
    teamA: { id: 1, name: '苏州KSG', shortName: 'KSG', score: 3, logo: '', color: '#8B5CF6' },
    teamB: { id: 8, name: '深圳DYG', shortName: 'DYG', score: 1, logo: '', color: '#00CED1' },
    result: 'KSG胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_r2_0225',
    tournament: '2026年KPL春季赛常规赛第二轮',
    stage: 'S/A组',
    date: '2026-02-25',
    time: '18:30',
    venue: '',
    status: 'finished',
    teamA: { id: 14, name: '北京JDG', shortName: 'JDG', score: 3, logo: '', color: '#0000CD' },
    teamB: { id: 9, name: '长沙TES.A', shortName: 'TES', score: 0, logo: '', color: '#20B2AA' },
    result: 'JDG胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true,
    note: 'JDG 4胜0负晋级卡位赛'
  },
  {
    id: 'm2026_r2_0224',
    tournament: '2026年KPL春季赛常规赛第二轮',
    stage: 'A/B组',
    date: '2026-02-24',
    time: '18:30',
    venue: '',
    status: 'finished',
    teamA: { id: 12, name: '杭州LGD.NBW', shortName: 'LGD', score: 2, logo: '', color: '#9370DB' },
    teamB: { id: 17, name: '无锡TCG', shortName: 'TCG', score: 3, logo: '', color: '#9370DB' },
    result: 'TCG胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_r2_0213',
    tournament: '2026年KPL春季赛常规赛第二轮',
    stage: 'S组',
    date: '2026-02-13',
    time: '18:30',
    venue: '',
    status: 'finished',
    teamA: { id: 3, name: '成都AG超玩会', shortName: 'AG', score: 2, logo: '', color: '#FF6B00' },
    teamB: { id: 14, name: '北京JDG', shortName: 'JDG', score: 3, logo: '', color: '#0000CD' },
    result: 'JDG胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_r2_0211b',
    tournament: '2026年KPL春季赛常规赛第二轮',
    stage: 'A组',
    date: '2026-02-11',
    time: '17:00',
    venue: '',
    status: 'finished',
    teamA: { id: 18, name: '桐乡情久', shortName: '情久', score: 0, logo: '', color: '#FF69B4' },
    teamB: { id: 8, name: '深圳DYG', shortName: 'DYG', score: 3, logo: '', color: '#00CED1' },
    result: 'DYG胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_r2_0211a',
    tournament: '2026年KPL春季赛常规赛第二轮',
    stage: 'S组',
    date: '2026-02-11',
    time: '14:00',
    venue: '',
    status: 'finished',
    teamA: { id: 6, name: '北京WB', shortName: 'WB', score: 3, logo: '', color: '#FF4500' },
    teamB: { id: 1, name: '苏州KSG', shortName: 'KSG', score: 2, logo: '', color: '#8B5CF6' },
    result: 'WB胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_r2_0208b',
    tournament: '2026年KPL春季赛常规赛第二轮',
    stage: 'S组',
    date: '2026-02-08',
    time: '20:00',
    venue: '',
    status: 'finished',
    teamA: { id: 4, name: '广州TTG', shortName: 'TTG', score: 2, logo: '', color: '#FF4444' },
    teamB: { id: 2, name: '重庆狼队', shortName: '狼队', score: 3, logo: '', color: '#FFD700' },
    result: '狼队胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_r2_0208a',
    tournament: '2026年KPL春季赛常规赛第二轮',
    stage: 'A组',
    date: '2026-02-08',
    time: '18:30',
    venue: '',
    status: 'finished',
    teamA: { id: 5, name: '武汉eStarPro', shortName: 'eStar', score: 3, logo: '', color: '#FFD700' },
    teamB: { id: 17, name: '无锡TCG', shortName: 'TCG', score: 1, logo: '', color: '#9370DB' },
    result: 'eStar胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_r2_0206',
    tournament: '2026年KPL春季赛常规赛第二轮',
    stage: 'S组',
    date: '2026-02-06',
    time: '18:30',
    venue: '',
    status: 'finished',
    teamA: { id: 2, name: '重庆狼队', shortName: '狼队', score: 3, logo: '', color: '#FFD700' },
    teamB: { id: 1, name: '苏州KSG', shortName: 'KSG', score: 0, logo: '', color: '#8B5CF6' },
    result: '狼队胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_r2_0205',
    tournament: '2026年KPL春季赛常规赛第二轮',
    stage: 'S/A组',
    date: '2026-02-05',
    time: '18:30',
    venue: '',
    status: 'finished',
    teamA: { id: 3, name: '成都AG超玩会', shortName: 'AG', score: 3, logo: '', color: '#FF6B00' },
    teamB: { id: 11, name: '西安WE', shortName: 'WE', score: 0, logo: '', color: '#FF69B4' },
    result: 'AG胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_r2_0204c',
    tournament: '2026年KPL春季赛常规赛第二轮',
    stage: 'A/B组',
    date: '2026-02-04',
    time: '20:00',
    venue: '',
    status: 'finished',
    teamA: { id: 10, name: '济南RW侠', shortName: 'RW', score: 2, logo: '', color: '#FF1493' },
    teamB: { id: 14, name: '北京JDG', shortName: 'JDG', score: 3, logo: '', color: '#0000CD' },
    result: 'JDG胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_r2_0204b',
    tournament: '2026年KPL春季赛常规赛第二轮',
    stage: 'A/B组',
    date: '2026-02-04',
    time: '17:00',
    venue: '',
    status: 'finished',
    teamA: { id: 1, name: '苏州KSG', shortName: 'KSG', score: 3, logo: '', color: '#8B5CF6' },
    teamB: { id: 18, name: '桐乡情久', shortName: '情久', score: 0, logo: '', color: '#FF69B4' },
    result: 'KSG胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_r2_0204a',
    tournament: '2026年KPL春季赛常规赛第二轮',
    stage: 'A/B组',
    date: '2026-02-04',
    time: '14:00',
    venue: '',
    status: 'finished',
    teamA: { id: 16, name: '南通Hero久竞', shortName: 'Hero', score: 3, logo: '', color: '#32CD32' },
    teamB: { id: 9, name: '长沙TES.A', shortName: 'TES', score: 2, logo: '', color: '#20B2AA' },
    result: 'Hero胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },

  // ===== 常规赛第一轮（24场） - 来源：kpl.qq.com + 快懂百科 + 虎扑 + 直播吧 =====
  {
    id: 'm2026_r1_0201',
    tournament: '2026年KPL春季赛常规赛第一轮',
    stage: '第1组',
    date: '2026-02-01',
    time: '18:30',
    venue: '',
    status: 'finished',
    teamA: { id: 6, name: '北京WB', shortName: 'WB', score: 3, logo: '', color: '#FF4500' },
    teamB: { id: 9, name: '上海EDG.M', shortName: 'EDG.M', score: 1, logo: '', color: '#9932CC' },
    result: 'WB胜',
    format: 'BO5',
    dataSource: 'https://m.hupu.com/bbs/637261842.html',
    verified: true
  },
  {
    id: 'm2026_r1_0131',
    tournament: '2026年KPL春季赛常规赛第一轮',
    stage: '第3组',
    date: '2026-01-31',
    time: '18:30',
    venue: '',
    status: 'finished',
    teamA: { id: 14, name: '北京JDG', shortName: 'JDG', score: 1, logo: '', color: '#0000CD' },
    teamB: { id: 4, name: '广州TTG', shortName: 'TTG', score: 3, logo: '', color: '#FF4444' },
    result: 'TTG胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true,
    note: 'TTG晋级第二轮S组'
  },
  {
    id: 'm2026_r1_0130b',
    tournament: '2026年KPL春季赛常规赛第一轮',
    stage: '第2组',
    date: '2026-01-30',
    time: '18:30',
    venue: '',
    status: 'finished',
    teamA: { id: 6, name: '北京WB', shortName: 'WB', score: 3, logo: '', color: '#FF4500' },
    teamB: { id: 18, name: '桐乡情久', shortName: '情久', score: 0, logo: '', color: '#FF69B4' },
    result: 'WB胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_r1_0130a',
    tournament: '2026年KPL春季赛常规赛第一轮',
    stage: '第2组',
    date: '2026-01-30',
    time: '15:00',
    venue: '',
    status: 'finished',
    teamA: { id: 12, name: '杭州LGD.NBW', shortName: 'LGD', score: 3, logo: '', color: '#9370DB' },
    teamB: { id: 13, name: '上海RNG.M', shortName: 'RNG.M', score: 2, logo: '', color: '#FF4500' },
    result: 'LGD胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_r1_0125d',
    tournament: '2026年KPL春季赛常规赛第一轮',
    stage: '第1组',
    date: '2026-01-25',
    time: '20:00',
    venue: '',
    status: 'finished',
    teamA: { id: 3, name: '成都AG超玩会', shortName: 'AG', score: 2, logo: '', color: '#FF6B00' },
    teamB: { id: 18, name: '桐乡情久', shortName: '情久', score: 3, logo: '', color: '#FF69B4' },
    result: '情久胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true,
    note: '情久首次进入S组'
  },
  {
    id: 'm2026_r1_0125c',
    tournament: '2026年KPL春季赛常规赛第一轮',
    stage: '第2组',
    date: '2026-01-25',
    time: '17:00',
    venue: '',
    status: 'finished',
    teamA: { id: 12, name: '杭州LGD.NBW', shortName: 'LGD', score: 0, logo: '', color: '#9370DB' },
    teamB: { id: 8, name: '深圳DYG', shortName: 'DYG', score: 3, logo: '', color: '#00CED1' },
    result: 'DYG胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_r1_0125b',
    tournament: '2026年KPL春季赛常规赛第一轮',
    stage: '第2组',
    date: '2026-01-25',
    time: '14:00',
    venue: '',
    status: 'finished',
    teamA: { id: 2, name: '重庆狼队', shortName: '狼队', score: 3, logo: '', color: '#FFD700' },
    teamB: { id: 13, name: '上海RNG.M', shortName: 'RNG.M', score: 1, logo: '', color: '#FF4500' },
    result: '狼队胜',
    format: 'BO5',
    dataSource: 'https://news.17173.com/content/01252026/202756565.shtml',
    verified: true
  },
  {
    id: 'm2026_r1_0123c',
    tournament: '2026年KPL春季赛常规赛第一轮',
    stage: '第2组',
    date: '2026-01-23',
    time: '20:00',
    venue: '',
    status: 'finished',
    teamA: { id: 10, name: '济南RW侠', shortName: 'RW', score: 0, logo: '', color: '#FF1493' },
    teamB: { id: 2, name: '重庆狼队', shortName: '狼队', score: 3, logo: '', color: '#FFD700' },
    result: '狼队胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_r1_0123b',
    tournament: '2026年KPL春季赛常规赛第一轮',
    stage: '第1组',
    date: '2026-01-23',
    time: '17:00',
    venue: '',
    status: 'finished',
    teamA: { id: 9, name: '长沙TES.A', shortName: 'TES', score: 3, logo: '', color: '#20B2AA' },
    teamB: { id: 9, name: '上海EDG.M', shortName: 'EDG.M', score: 2, logo: '', color: '#9932CC' },
    result: 'TES胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_r1_0123a',
    tournament: '2026年KPL春季赛常规赛第一轮',
    stage: '第2组',
    date: '2026-01-23',
    time: '14:00',
    venue: '',
    status: 'finished',
    teamA: { id: 11, name: '西安WE', shortName: 'WE', score: 3, logo: '', color: '#FF69B4' },
    teamB: { id: 12, name: '杭州LGD.NBW', shortName: 'LGD', score: 0, logo: '', color: '#9370DB' },
    result: 'WE胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_r1_0122b',
    tournament: '2026年KPL春季赛常规赛第一轮',
    stage: '第3组',
    date: '2026-01-22',
    time: '20:00',
    venue: '',
    status: 'finished',
    teamA: { id: 16, name: '南通Hero久竞', shortName: 'Hero', score: 3, logo: '', color: '#32CD32' },
    teamB: { id: 1, name: '苏州KSG', shortName: 'KSG', score: 2, logo: '', color: '#8B5CF6' },
    result: 'Hero胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_r1_0122a',
    tournament: '2026年KPL春季赛常规赛第一轮',
    stage: '第2组',
    date: '2026-01-22',
    time: '18:30',
    venue: '',
    status: 'finished',
    teamA: { id: 8, name: '深圳DYG', shortName: 'DYG', score: 3, logo: '', color: '#00CED1' },
    teamB: { id: 13, name: '上海RNG.M', shortName: 'RNG.M', score: 1, logo: '', color: '#FF4500' },
    result: 'DYG胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_r1_0121b',
    tournament: '2026年KPL春季赛常规赛第一轮',
    stage: '第2组',
    date: '2026-01-21',
    time: '17:00',
    venue: '',
    status: 'finished',
    teamA: { id: 11, name: '西安WE', shortName: 'WE', score: 3, logo: '', color: '#FF69B4' },
    teamB: { id: 10, name: '济南RW侠', shortName: 'RW', score: 0, logo: '', color: '#FF1493' },
    result: 'WE胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_r1_0121a',
    tournament: '2026年KPL春季赛常规赛第一轮',
    stage: '第1组',
    date: '2026-01-21',
    time: '14:00',
    venue: '',
    status: 'finished',
    teamA: { id: 18, name: '桐乡情久', shortName: '情久', score: 3, logo: '', color: '#FF69B4' },
    teamB: { id: 9, name: '上海EDG.M', shortName: 'EDG.M', score: 1, logo: '', color: '#9932CC' },
    result: '情久胜',
    format: 'BO5',
    dataSource: 'https://m.baike.com/wiki/2026%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7589186583761518607',
    verified: true
  },
  {
    id: 'm2026_r1_0118',
    tournament: '2026年KPL春季赛常规赛第一轮',
    stage: '第2组',
    date: '2026-01-18',
    time: '18:30',
    venue: '',
    status: 'finished',
    teamA: { id: 10, name: '济南RW侠', shortName: 'RW', score: 3, logo: '', color: '#FF1493' },
    teamB: { id: 12, name: '杭州LGD.NBW', shortName: 'LGD', score: 2, logo: '', color: '#9370DB' },
    result: 'RW胜',
    format: 'BO5',
    dataSource: 'https://m.zhibo8.com/news/web/other/2026-01-18/696c5e678e2b3native.htm',
    verified: true
  },
  {
    id: 'm2026_r1_0116c',
    tournament: '2026年KPL春季赛常规赛第一轮',
    stage: '第2组',
    date: '2026-01-16',
    time: '20:00',
    venue: '',
    status: 'finished',
    teamA: { id: 12, name: '杭州LGD.NBW', shortName: 'LGD', score: 2, logo: '', color: '#9370DB' },
    teamB: { id: 2, name: '重庆狼队', shortName: '狼队', score: 3, logo: '', color: '#FFD700' },
    result: '狼队胜',
    format: 'BO5',
    dataSource: 'https://kpl.qq.com/#/Schedule',
    verified: true
  },
  {
    id: 'm2026_r1_0116b',
    tournament: '2026年KPL春季赛常规赛第一轮',
    stage: '第2组',
    date: '2026-01-16',
    time: '17:00',
    venue: '',
    status: 'finished',
    teamA: { id: 11, name: '西安WE', shortName: 'WE', score: 2, logo: '', color: '#FF69B4' },
    teamB: { id: 13, name: '上海RNG.M', shortName: 'RNG.M', score: 3, logo: '', color: '#FF4500' },
    result: 'RNG.M胜',
    format: 'BO5',
    dataSource: 'https://kpl.qq.com/#/Schedule',
    verified: true
  },
  {
    id: 'm2026_r1_0116a',
    tournament: '2026年KPL春季赛常规赛第一轮',
    stage: '第2组',
    date: '2026-01-16',
    time: '14:00',
    venue: '',
    status: 'finished',
    teamA: { id: 8, name: '深圳DYG', shortName: 'DYG', score: 1, logo: '', color: '#00CED1' },
    teamB: { id: 10, name: '济南RW侠', shortName: 'RW', score: 3, logo: '', color: '#FF1493' },
    result: 'RW胜',
    format: 'BO5',
    dataSource: 'https://kpl.qq.com/#/Schedule',
    verified: true
  },
  {
    id: 'm2026_r1_0115c',
    tournament: '2026年KPL春季赛常规赛第一轮',
    stage: '第3组',
    date: '2026-01-15',
    time: '20:00',
    venue: '',
    status: 'finished',
    teamA: { id: 7, name: '佛山DRG', shortName: 'DRG', score: 1, logo: '', color: '#00D4FF' },
    teamB: { id: 1, name: '苏州KSG', shortName: 'KSG', score: 3, logo: '', color: '#8B5CF6' },
    result: 'KSG胜',
    format: 'BO5',
    dataSource: 'https://www.sina.cn/news/detail/5251343284702919.html',
    verified: true
  },
  {
    id: 'm2026_r1_0115b',
    tournament: '2026年KPL春季赛常规赛第一轮',
    stage: '第3组',
    date: '2026-01-15',
    time: '17:00',
    venue: '',
    status: 'finished',
    teamA: { id: 16, name: '南通Hero久竞', shortName: 'Hero', score: 1, logo: '', color: '#32CD32' },
    teamB: { id: 4, name: '广州TTG', shortName: 'TTG', score: 3, logo: '', color: '#FF4444' },
    result: 'TTG胜',
    format: 'BO5',
    dataSource: 'https://www.sina.cn/news/detail/5251343284702919.html',
    verified: true
  },
  {
    id: 'm2026_r1_0115a',
    tournament: '2026年KPL春季赛常规赛第一轮',
    stage: '第1组',
    date: '2026-01-15',
    time: '14:00',
    venue: '',
    status: 'finished',
    teamA: { id: 18, name: '桐乡情久', shortName: '情久', score: 3, logo: '', color: '#FF69B4' },
    teamB: { id: 9, name: '长沙TES.A', shortName: 'TES', score: 0, logo: '', color: '#20B2AA' },
    result: '情久胜',
    format: 'BO5',
    dataSource: 'https://www.sina.cn/news/detail/5251343284702919.html',
    verified: true
  },
  {
    id: 'm2026_r1_0114d',
    tournament: '2026年KPL春季赛常规赛第一轮',
    stage: '开幕战',
    date: '2026-01-14',
    time: '20:00',
    venue: '',
    status: 'finished',
    teamA: { id: 6, name: '北京WB', shortName: 'WB', score: 3, logo: '', color: '#FF4500' },
    teamB: { id: 3, name: '成都AG超玩会', shortName: 'AG', score: 2, logo: '', color: '#FF6B00' },
    result: 'WB胜',
    format: 'BO5',
    dataSource: 'http://pvp.qq.com/matchdata/schedule.html?league_id=20260001',
    verified: true,
    note: '揭幕战焦点对决'
  },
  {
    id: 'm2026_r1_0114c',
    tournament: '2026年KPL春季赛常规赛第一轮',
    stage: '开幕战',
    date: '2026-01-14',
    time: '17:00',
    venue: '',
    status: 'finished',
    teamA: { id: 8, name: '深圳DYG', shortName: 'DYG', score: 3, logo: '', color: '#00CED1' },
    teamB: { id: 2, name: '重庆狼队', shortName: '狼队', score: 1, logo: '', color: '#FFD700' },
    result: 'DYG胜',
    format: 'BO5',
    dataSource: 'http://pvp.qq.com/matchdata/schedule.html?league_id=20260001',
    verified: true
  },
  {
    id: 'm2026_r1_0114a',
    tournament: '2026年KPL春季赛常规赛第一轮',
    stage: '开幕战',
    date: '2026-01-14',
    time: '14:00',
    venue: '',
    status: 'finished',
    teamA: { id: 14, name: '北京JDG', shortName: 'JDG', score: 3, logo: '', color: '#0000CD' },
    teamB: { id: 5, name: '武汉eStarPro', shortName: 'eStar', score: 2, logo: '', color: '#FFD700' },
    result: 'JDG胜',
    format: 'BO5',
    dataSource: 'http://pvp.qq.com/matchdata/schedule.html?league_id=20260001',
    verified: true,
    note: '2026春季赛首战'
  },

  // ==================== 2025年KPL赛事数据（来源：快懂百科 + 腾讯新闻 + 虎扑） ====================
  
  // ===== 2025年年度总决赛 =====
  {
    id: 'm2025_annual_final',
    tournament: '2025年KPL年度总决赛',
    stage: '总决赛',
    date: '2025-11-08',
    time: '18:00',
    venue: '北京国家体育场·鸟巢',
    status: 'finished',
    teamA: { id: 3, name: '成都AG超玩会', shortName: 'AG', score: 4, logo: '', color: '#FF6B00' },
    teamB: { id: 2, name: '重庆狼队', shortName: '狼队', score: 2, logo: '', color: '#FFD700' },
    result: 'AG胜',
    format: 'BO7',
    dataSource: 'https://m.baike.com/wiki/2025%E5%B9%B4KPL%E5%B9%B4%E5%BA%A6%E6%80%BB%E5%86%B3%E8%B5%9B',
    verified: true,
    note: 'AG六连冠，现场观众62196人创吉尼斯纪录，FMVP：一诺'
  },

  // ===== 2025年夏季赛 =====
  {
    id: 'm2025_summer_final',
    tournament: '2025年KPL夏季赛总决赛',
    stage: '总决赛',
    date: '2025-09-07',
    time: '18:00',
    venue: '杭州奥体中心体育馆',
    status: 'finished',
    teamA: { id: 3, name: '成都AG超玩会', shortName: 'AG', score: 4, logo: '', color: '#FF6B00' },
    teamB: { id: 6, name: '北京WB', shortName: 'WB', score: 1, logo: '', color: '#FF4500' },
    result: 'AG胜',
    format: 'BO7',
    dataSource: 'https://news.qq.com/rain/a/20250907A06S9B00',
    verified: true,
    note: 'AG五连冠，FMVP：大帅'
  },

  // ===== 2025年春季赛 =====
  {
    id: 'm2025_spring_final',
    tournament: '2025年KPL春季赛总决赛',
    stage: '总决赛',
    date: '2025-05-10',
    time: '18:00',
    venue: '郑州奥林匹克体育中心',
    status: 'finished',
    teamA: { id: 3, name: '成都AG超玩会', shortName: 'AG', score: 4, logo: '', color: '#FF6B00' },
    teamB: { id: 10, name: '佛山DRG', shortName: 'DRG', score: 1, logo: '', color: '#1E90FF' },
    result: 'AG胜',
    format: 'BO7',
    dataSource: 'https://m.baike.com/wiki/2025%E5%B9%B4KPL%E6%98%A5%E5%AD%A3%E8%B5%9B/7460780032819085349',
    verified: true,
    note: 'AG四连冠，队史第六冠，FMVP：钟意'
  },

  // ==================== 2024年KPL赛事数据（来源：央视网 + 虎扑 + 新浪新闻） ====================
  
  // ===== 2024年挑战者杯 =====
  {
    id: 'm2024_challenger_final',
    tournament: '2024年王者荣耀挑战者杯总决赛',
    stage: '总决赛',
    date: '2025-01-11',
    time: '18:00',
    venue: '',
    status: 'finished',
    teamA: { id: 3, name: '成都AG超玩会', shortName: 'AG', score: 5, logo: '', color: '#FF6B00' },
    teamB: { id: 2, name: '重庆狼队', shortName: '狼队', score: 3, logo: '', color: '#FFD700' },
    result: 'AG胜',
    format: 'BO9',
    dataSource: 'https://k.sina.cn/article_7857201856_1d45362c001903yu08.html',
    verified: true,
    note: 'AG三连冠，首个BO9冠军，FMVP：钟意'
  },

  // ===== 2024年年度总决赛 =====
  {
    id: 'm2024_annual_final',
    tournament: '2024年KPL年度总决赛',
    stage: '总决赛',
    date: '2024-11-16',
    time: '17:30',
    venue: '北京工人体育场',
    status: 'finished',
    teamA: { id: 3, name: '成都AG超玩会', shortName: 'AG', score: 4, logo: '', color: '#FF6B00' },
    teamB: { id: 2, name: '重庆狼队', shortName: '狼队', score: 2, logo: '', color: '#FFD700' },
    result: 'AG胜',
    format: 'BO7',
    dataSource: 'https://sports.cctv.com/2024/11/17/ARTIIPWQlxZLNsuxJDCbVC8P241117.shtml',
    verified: true,
    note: 'AG首夺年总冠军，队史第四冠，FMVP：长生'
  },

  // ===== 2024年夏季赛 =====
  {
    id: 'm2024_summer_final',
    tournament: '2024年KPL夏季赛总决赛',
    stage: '总决赛',
    date: '2024-09-15',
    time: '18:00',
    venue: '',
    status: 'finished',
    teamA: { id: 3, name: '成都AG超玩会', shortName: 'AG', score: 4, logo: '', color: '#FF6B00' },
    teamB: { id: 1, name: '苏州KSG', shortName: 'KSG', score: 1, logo: '', color: '#8B5CF6' },
    result: 'AG胜',
    format: 'BO7',
    dataSource: 'https://k.sina.cn/article_7857201856_1d45362c001903yu08.html',
    verified: true,
    note: 'AG队史第三冠，FMVP：钟意'
  },

  // ===== 2024年春季赛 =====
  {
    id: 'm2024_spring_final',
    tournament: '2024年KPL春季赛总决赛',
    stage: '总决赛',
    date: '2024-05-18',
    time: '18:00',
    venue: '',
    status: 'finished',
    teamA: { id: 2, name: '重庆狼队', shortName: '狼队', score: 4, logo: '', color: '#FFD700' },
    teamB: { id: 3, name: '成都AG超玩会', shortName: 'AG', score: 3, logo: '', color: '#FF6B00' },
    result: '狼队胜',
    format: 'BO7',
    dataSource: 'https://k.sina.cn/article_7857201856_1d45362c001903yu08.html',
    verified: true,
    note: '狼队第十冠，队史里程碑，FMVP：小胖'
  },

  // ==================== 2023年KPL赛事数据（来源：虎扑 + 央视网） ====================
  
  // ===== 2023年世界冠军杯 =====
  {
    id: 'm2023_world_final',
    tournament: '2023年王者荣耀世界冠军杯总决赛',
    stage: '总决赛',
    date: '2023-11-11',
    time: '18:00',
    venue: '',
    status: 'finished',
    teamA: { id: 3, name: '成都AG超玩会', shortName: 'AG', score: 4, logo: '', color: '#FF6B00' },
    teamB: { id: 6, name: '北京WB', shortName: 'WB', score: 2, logo: '', color: '#FF4500' },
    result: 'AG胜',
    format: 'BO7',
    dataSource: 'https://voice.hupu.com/bbs/635635451',
    verified: true,
    note: 'AG世冠首冠，FMVP：一诺'
  },

  // ===== 2023年挑战者杯 =====
  {
    id: 'm2023_challenger_final',
    tournament: '2023年王者荣耀挑战者杯总决赛',
    stage: '总决赛',
    date: '2023-11-05',
    time: '18:00',
    venue: '苏州奥林匹克体育中心体育馆',
    status: 'finished',
    teamA: { id: 2, name: '重庆狼队', shortName: '狼队', score: 4, logo: '', color: '#FFD700' },
    teamB: { id: 3, name: '成都AG超玩会', shortName: 'AG', score: 2, logo: '', color: '#FF6B00' },
    result: '狼队胜',
    format: 'BO7',
    dataSource: 'https://v.cctv.com/2023/11/11/ARTIDMjcSL5YZwWXsfSPUXuW231111.shtml',
    verified: true,
    note: '狼队第九冠，FMVP：小胖'
  },

  // ===== 2023年夏季赛 =====
  {
    id: 'm2023_summer_final',
    tournament: '2023年KPL夏季赛总决赛',
    stage: '总决赛',
    date: '2023-09-10',
    time: '18:00',
    venue: '',
    status: 'finished',
    teamA: { id: 4, name: '广州TTG', shortName: 'TTG', score: 4, logo: '', color: '#FF4444' },
    teamB: { id: 2, name: '重庆狼队', shortName: '狼队', score: 2, logo: '', color: '#FFD700' },
    result: 'TTG胜',
    format: 'BO7',
    dataSource: 'https://voice.hupu.com/bbs/635635451',
    verified: true,
    note: 'TTG队史首冠，FMVP：不然'
  },

  // ===== 2023年春季赛 =====
  {
    id: 'm2023_spring_final',
    tournament: '2023年KPL春季赛总决赛',
    stage: '总决赛',
    date: '2023-05-13',
    time: '18:00',
    venue: '',
    status: 'finished',
    teamA: { id: 2, name: '重庆狼队', shortName: '狼队', score: 4, logo: '', color: '#FFD700' },
    teamB: { id: 6, name: '北京WB', shortName: 'WB', score: 1, logo: '', color: '#FF4500' },
    result: '狼队胜',
    format: 'BO7',
    dataSource: 'https://voice.hupu.com/bbs/635635451',
    verified: true,
    note: '狼队第八冠，FMVP：Fly'
  },

  // ==================== 2022年KPL赛事数据（来源：腾讯新闻 + 今日头条 + 新浪新闻） ====================
  
  // ===== 2022年世界冠军杯(KIC) =====
  {
    id: 'm2022_world_final',
    tournament: '2022年王者荣耀世界冠军杯(KIC)总决赛',
    stage: '总决赛',
    date: '2022-12-30',
    time: '18:00',
    venue: '',
    status: 'finished',
    teamA: { id: 5, name: '武汉eStarPro', shortName: 'eStar', score: 4, logo: '', color: '#FFD700' },
    teamB: { id: 10, name: '佛山DRG', shortName: 'DRG', score: 2, logo: '', color: '#1E90FF' },
    result: 'eStar胜',
    format: 'BO7',
    dataSource: 'https://voice.hupu.com/bbs/635635451',
    verified: true,
    note: 'eStar三连冠，FMVP：花海'
  },

  // ===== 2022年挑战者杯 =====
  {
    id: 'm2022_challenger_final',
    tournament: '2022年王者荣耀挑战者杯总决赛',
    stage: '总决赛',
    date: '2022-12-??',
    time: '18:00',
    venue: '',
    status: 'finished',
    teamA: { id: 5, name: '武汉eStarPro', shortName: 'eStar', score: 4, logo: '', color: '#FFD700' },
    teamB: { id: 6, name: '北京WB', shortName: 'WB', score: 3, logo: '', color: '#FF4500' },
    result: 'eStar胜',
    format: 'BO7',
    dataSource: 'https://voice.hupu.com/bbs/635635451',
    verified: true,
    note: 'eStar挑战者杯三连冠，FMVP：子阳'
  },

  // ===== 2022年夏季赛 =====
  {
    id: 'm2022_summer_final',
    tournament: '2022年KPL夏季赛总决赛',
    stage: '总决赛',
    date: '2022-09-03',
    time: '19:30',
    venue: '上海',
    status: 'finished',
    teamA: { id: 2, name: '重庆狼队', shortName: '狼队', score: 4, logo: '', color: '#FFD700' },
    teamB: { id: 5, name: '武汉eStarPro', shortName: 'eStar', score: 2, logo: '', color: '#FFD700' },
    result: '狼队胜',
    format: 'BO7',
    dataSource: 'http://news.qq.com/rain/a/20220904A00XD500',
    verified: true,
    note: '狼队时隔五年再夺联赛冠军，第七冠，FMVP：小胖'
  },

  // ===== 2022年春季赛 =====
  {
    id: 'm2022_spring_final',
    tournament: '2022年KPL春季赛总决赛',
    stage: '总决赛',
    date: '2022-05-18',
    time: '18:00',
    venue: '',
    status: 'finished',
    teamA: { id: 5, name: '武汉eStarPro', shortName: 'eStar', score: 4, logo: '', color: '#FFD700' },
    teamB: { id: 2, name: '重庆狼队', shortName: '狼队', score: 0, logo: '', color: '#FFD700' },
    result: 'eStar胜',
    format: 'BO7',
    dataSource: 'https://k.sina.cn/article_1403377667_53a5d80300101d7jv.html',
    verified: true,
    note: 'eStar零封狼队，创最快总决赛纪录，FMVP：坦然'
  },

  // ==================== 2021年KPL赛事数据（来源：腾讯体育 + 澎湃新闻 + 快懂百科） ====================
  
  // ===== 2021年挑战者杯 =====
  {
    id: 'm2021_challenger_final',
    tournament: '2021年王者荣耀挑战者杯总决赛',
    stage: '总决赛',
    date: '2022-01-15',
    time: '18:00',
    venue: '',
    status: 'finished',
    teamA: { id: 5, name: '武汉eStarPro', shortName: 'eStar', score: 4, logo: '', color: '#FFD700' },
    teamB: { id: 4, name: '广州TTG', shortName: 'TTG', score: 1, logo: '', color: '#FF4444' },
    result: 'eStar胜',
    format: 'BO7',
    dataSource: 'https://voice.hupu.com/bbs/635635451',
    verified: true,
    note: 'eStar挑战者杯两连冠，FMVP：坦然'
  },

  // ===== 2021年秋季赛（绝版秋季赛） =====
  {
    id: 'm2021_autumn_final',
    tournament: '2021年KPL秋季赛总决赛',
    stage: '总决赛',
    date: '2021-12-25',
    time: '18:00',
    venue: '苏州',
    status: 'finished',
    teamA: { id: 5, name: '武汉eStarPro', shortName: 'eStar', score: 4, logo: '', color: '#FFD700' },
    teamB: { id: 4, name: '广州TTG', shortName: 'TTG', score: 1, logo: '', color: '#FF4444' },
    result: 'eStar胜',
    format: 'BO7',
    dataSource: 'http://m.toutiao.com/group/7045791963056079374',
    verified: true,
    note: '绝版秋季赛冠军，eStar队史首座秋季赛冠军，FMVP：花海'
  },

  // ===== 2021年世界冠军杯 =====
  {
    id: 'm2021_world_final',
    tournament: '2021年王者荣耀世界冠军杯总决赛',
    stage: '总决赛',
    date: '2021-08-28',
    time: '18:00',
    venue: '',
    status: 'finished',
    teamA: { id: 2, name: '重庆QGhappy', shortName: 'QG', score: 4, logo: '', color: '#FFD700' },
    teamB: { id: 10, name: '佛山GK', shortName: 'GK', score: 2, logo: '', color: '#1E90FF' },
    result: 'QG胜',
    format: 'BO7',
    dataSource: 'https://voice.hupu.com/bbs/635635451',
    verified: true,
    note: 'QG第六冠，FMVP：Fly'
  },

  // ===== 2021年春季赛 =====
  {
    id: 'm2021_spring_final',
    tournament: '2021年KPL春季赛总决赛',
    stage: '总决赛',
    date: '2021-06-26',
    time: '18:00',
    venue: '',
    status: 'finished',
    teamA: { id: 16, name: '南京Hero久竞', shortName: 'Hero', score: 4, logo: '', color: '#DC143C' },
    teamB: { id: 4, name: '广州TTG', shortName: 'TTG', score: 3, logo: '', color: '#FF4444' },
    result: 'Hero胜',
    format: 'BO7',
    dataSource: 'https://kbsapp.sports.qq.com/article/20210626A0B901',
    verified: true,
    note: 'Hero春季赛第二冠，FMVP：清融'
  },

  // ==================== 2020年KPL赛事数据（来源：快懂百科 + 虎扑 + 腾讯新闻） ====================
  
  // ===== 2020年冬季冠军杯（挑杯前身） =====
  {
    id: 'm2020_winter_final',
    tournament: '2020年冬季冠军杯总决赛',
    stage: '总决赛',
    date: '2021-01-23',
    time: '18:00',
    venue: '',
    status: 'finished',
    teamA: { id: 16, name: '南京Hero久竞', shortName: 'Hero', score: 4, logo: '', color: '#DC143C' },
    teamB: { id: 8, name: '深圳DYG', shortName: 'DYG', score: 1, logo: '', color: '#00CED1' },
    result: 'Hero胜',
    format: 'BO7',
    dataSource: 'https://voice.hupu.com/bbs/635635451',
    verified: true,
    note: 'Hero冬冠首冠，FMVP：清融'
  },

  // ===== 2020年秋季赛 =====
  {
    id: 'm2020_autumn_final',
    tournament: '2020年KPL秋季赛总决赛',
    stage: '总决赛',
    date: '2020-12-19',
    time: '18:00',
    venue: '',
    status: 'finished',
    teamA: { id: 8, name: '深圳DYG', shortName: 'DYG', score: 4, logo: '', color: '#00CED1' },
    teamB: { id: 3, name: '成都AG超玩会', shortName: 'AG', score: 0, logo: '', color: '#FF6B00' },
    result: 'DYG胜',
    format: 'BO7',
    dataSource: 'http://news.qq.com/rain/a/20201220A08DV800',
    verified: true,
    note: 'DYG队史首冠，FMVP：小义'
  },

  // ===== 2020年世界冠军杯 =====
  {
    id: 'm2020_world_final',
    tournament: '2020年王者荣耀世界冠军杯总决赛',
    stage: '总决赛',
    date: '2020-08-08',
    time: '18:00',
    venue: '',
    status: 'finished',
    teamA: { id: 17, name: 'TS', shortName: 'TS', score: 4, logo: '', color: '#32CD32' },
    teamB: { id: 8, name: '深圳DYG', shortName: 'DYG', score: 3, logo: '', color: '#00CED1' },
    result: 'TS胜',
    format: 'BO7',
    dataSource: 'https://view.inews.qq.com/a/20210131A07E5U00',
    verified: true,
    note: 'TS让三追四奇迹夺冠，FMVP：暖阳'
  },

  // ===== 2020年春季赛 =====
  {
    id: 'm2020_spring_final',
    tournament: '2020年KPL春季赛总决赛',
    stage: '总决赛',
    date: '2020-06-13',
    time: '18:00',
    venue: '上海',
    status: 'finished',
    teamA: { id: 17, name: 'TS', shortName: 'TS', score: 4, logo: '', color: '#32CD32' },
    teamB: { id: 3, name: '成都AG超玩会', shortName: 'AG', score: 3, logo: '', color: '#FF6B00' },
    result: 'TS胜',
    format: 'BO7',
    dataSource: 'https://m.chaofan.com/news/lymsrcospd7kh6l.html',
    verified: true,
    note: 'TS败者组一穿六夺冠，FMVP：暖阳'
  },

  // ==================== 2019年KPL赛事数据（来源：快懂百科 + 游民星空 + 虎扑 + 腾讯体育） ====================
  
  // ===== 2019年冬季冠军杯 =====
  {
    id: 'm2019_winter_final',
    tournament: '2019年冬季冠军杯总决赛',
    stage: '总决赛',
    date: '2020-01-04',
    time: '18:00',
    venue: '',
    status: 'finished',
    teamA: { id: 2, name: '重庆QGhappy', shortName: 'QG', score: 4, logo: '', color: '#FFD700' },
    teamB: { id: 5, name: '武汉eStarPro', shortName: 'eStar', score: 3, logo: '', color: '#FFD700' },
    result: 'QG胜',
    format: 'BO7',
    dataSource: 'https://view.inews.qq.com/k/20200111A0PDVE00?no-redirect=1',
    verified: true,
    note: 'QG第五冠'
  },

  // ===== 2019年秋季赛 =====
  {
    id: 'm2019_autumn_final',
    tournament: '2019年KPL秋季赛总决赛',
    stage: '总决赛',
    date: '2019-12-14',
    time: '18:00',
    venue: '',
    status: 'finished',
    teamA: { id: 3, name: '成都AG超玩会', shortName: 'AG', score: 4, logo: '', color: '#FF6B00' },
    teamB: { id: 2, name: '重庆QGhappy', shortName: 'QG', score: 1, logo: '', color: '#FFD700' },
    result: 'AG胜',
    format: 'BO7',
    dataSource: 'https://kbsapp.sports.qq.com/article/20191214006113',
    verified: true,
    note: 'AG队史首冠，老帅FMVP，终结对QG八败纪录'
  },

  // ===== 2019年世界冠军杯 =====
  {
    id: 'm2019_world_final',
    tournament: '2019年王者荣耀世界冠军杯总决赛',
    stage: '总决赛',
    date: '2019-08-10',
    time: '18:00',
    venue: '',
    status: 'finished',
    teamA: { id: 5, name: '武汉eStarPro', shortName: 'eStar', score: 4, logo: '', color: '#FFD700' },
    teamB: { id: 15, name: 'RW侠', shortName: 'RW', score: 2, logo: '', color: '#FF1493' },
    result: 'eStar胜',
    format: 'BO7',
    dataSource: 'https://view.inews.qq.com/k/20200111A0PDVE00?no-redirect=1',
    verified: true,
    note: 'eStar世冠首冠'
  },

  // ===== 2019年春季赛 =====
  {
    id: 'm2019_spring_final',
    tournament: '2019年KPL春季赛总决赛',
    stage: '总决赛',
    date: '2019-06-15',
    time: '18:00',
    venue: '西安曲江国际会展中心',
    status: 'finished',
    teamA: { id: 5, name: '武汉eStarPro', shortName: 'eStar', score: 4, logo: '', color: '#FFD700' },
    teamB: { id: 12, name: 'RNG.M', shortName: 'RNG.M', score: 2, logo: '', color: '#FF4500' },
    result: 'eStar胜',
    format: 'BO7',
    dataSource: 'https://wap.gamersky.com/news/Content-1194267.html',
    verified: true,
    note: 'eStar征战六届终圆梦，Cat FMVP'
  }
]

// API接口配置
export const API_CONFIG = {
  baseURL: 'https://kpl.qq.com',
  endpoints: {
    schedule: '/api/schedule',
    matchDetail: '/api/match/:id',
    liveMatches: '/api/live',
    teams: '/api/teams'
  },
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
}

// 数据获取服务
export const fetchScheduleFromAPI = async () => {
  try {
    console.log('正在尝试连接KPL官方API...')
    
    const response = await fetch(`${API_CONFIG.baseURL}${API_CONFIG.endpoints.schedule}`, {
      method: 'GET',
      headers: API_CONFIG.headers,
      mode: 'cors'
    })
    
    if (!response.ok) {
      throw new Error(`API请求失败: ${response.status}`)
    }
    
    const data = await response.json()
    console.log('成功获取API数据:', data)
    return data
    
  } catch (error) {
    console.warn('无法连接到KPL官方API，使用本地缓存数据:', error.message)
    console.info('提示：KPL官网可能需要特殊认证或使用内部API')
    return null
  }
}

export default matchesDB
